export const MAX_PHOTO_AI_PROMPT_LENGTH = 500;

const PROMPT_INJECTION_PATTERNS: RegExp[] = [
  /ignore\s+(all\s+)?previous\s+instructions/i,
  /disregard\s+(all\s+)?(prior|previous)\s+instructions/i,
  /\bsystem\s*:/i,
  /\bassistant\s*:/i,
  /\buser\s*:/i,
  /<\s*\/?\s*system\s*>/i,
  /\[\s*INST\s*\]/i,
];

export function sanitizePhotoAiPrompt(raw: string): string {
  return raw
    .split("")
    .filter((char) => {
      const code = char.charCodeAt(0);
      return code > 31 && code !== 127;
    })
    .join("")
    .trim();
}

export function validatePhotoAiPrompt(raw: string): string | null {
  if (raw == null) {
    return "Informe o que deseja editar na imagem.";
  }

  const sanitized = sanitizePhotoAiPrompt(raw);

  if (sanitized.length === 0) {
    return "Informe o que deseja editar na imagem.";
  }

  if (sanitized.length > MAX_PHOTO_AI_PROMPT_LENGTH) {
    return `O prompt deve ter no máximo ${MAX_PHOTO_AI_PROMPT_LENGTH} caracteres.`;
  }

  for (const pattern of PROMPT_INJECTION_PATTERNS) {
    if (pattern.test(sanitized)) {
      return "Prompt inválido. Remova instruções de sistema ou comandos não permitidos.";
    }
  }

  return null;
}
